module.exports = __webpack_public_path__ + "static/media/scratch.17fde8ab.png";